import {Configuration, LocaleConfig} from "core/configuration/ConfigManager";
import Platform from "platform/Platform";
import {Http} from "platform/network/http/Http";
import {Logger} from "platform/logger/Logger";

export class Locale {

    private static readonly _logger: Logger = Logger.Of("Locale");
    private static _config: LocaleConfig;

    private constructor() {
    }


    public static get config(): LocaleConfig {
        return this._config;
    }

    public static async load(): Promise<void> {
        Locale._config = Platform.config<Configuration>().locale;
        if (navigator && navigator.language) {
            Http.getJson("resources/locales/" + navigator.language + ".json").then((data) => {
                Locale._config = data;
            }).catch((e) => {
                Locale._logger.debug("Failed load locale for language: " + navigator.language);
            });
        }
    }
}
